// @mui
import Container from '@mui/material/Container';
// hooks
// _mock
// components
import { useSettingsContext } from 'src/components/settings';
import GeneralCreatePage from './general-create-page';
// assets
//

// ----------------------------------------------------------------------

export default function Creategeneral() {
    // const { user } = useMockedUser();
    const settings = useSettingsContext();
    return (
        <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
            <GeneralCreatePage />
        </Container >
    );
}
